/** Waits (polling) until the Google Maps Places API is available. */
export function whenGoogleReady(callback: () => void, maxWaitMs = 10000): void {
  if (window.google?.maps?.places) {
    callback();
    return;
  }
  const start = Date.now();
  const interval = window.setInterval(() => {
    if (window.google?.maps?.places) {
      clearInterval(interval);
      callback();
    } else if (Date.now() - start > maxWaitMs) {
      clearInterval(interval);
      console.warn(`[whenGoogleReady] Google Maps API nie załadowało się w ciągu ${maxWaitMs}ms`);
    }
  }, 100);
}

export function clamp(value: number, { min, max }: { min: number; max: number }): number {
  return Math.min(max, Math.max(min, value));
}

export function getDeviceType(): 'mobile' | 'desktop' {
  return /Android|iPhone|iPad|iPod|Windows Phone|Mobi/i.test(navigator.userAgent) ? 'mobile' : 'desktop';
}

export function setCookie(name: string, value: string, days?: number): void {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/; SameSite=Lax`;
}

export function getCookie(name: string): string | null {
  const nameEQ = name + '=';
  for (const rawCookie of document.cookie.split(';')) {
    const cookie = rawCookie.trim();
    if (cookie.startsWith(nameEQ)) return cookie.substring(nameEQ.length);
  }
  return null;
}

/**
 * Splits "Berlin Brandenburg Airport (BER), Hartmann Rd..." into the part
 * before the first comma (displayed bold) and the rest.
 */
export function splitRouteAddress(fullAddress: string): { main: string; rest: string } {
  if (!fullAddress) return { main: '', rest: '' };
  const idx = fullAddress.indexOf(',');
  if (idx === -1) return { main: fullAddress, rest: '' };
  return {
    main: fullAddress.substring(0, idx).trim(),
    rest: fullAddress.substring(idx).trim(),
  };
}
